import { render, staticRenderFns } from "./RightBaseItem.vue?vue&type=template&id=2aba12c5&scoped=true"
import script from "./RightBaseItem.vue?vue&type=script&lang=js"
export * from "./RightBaseItem.vue?vue&type=script&lang=js"
import style0 from "./RightBaseItem.vue?vue&type=style&index=0&id=2aba12c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba12c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aba12c5')) {
      api.createRecord('2aba12c5', component.options)
    } else {
      api.reload('2aba12c5', component.options)
    }
    module.hot.accept("./RightBaseItem.vue?vue&type=template&id=2aba12c5&scoped=true", function () {
      api.rerender('2aba12c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/components/RightBaseItem.vue"
export default component.exports